import type { IPaymentSystemSettings } from '../types';

export const TRANSLATION_GROUP_PAYMENT_SYSTEMS = Symbol('payment-systems');

export const PAYMENT_SYSTEMS: IPaymentSystemSettings[] = [
  {
    name: 'Epayments',
    localizationShortCode: 'epayments.',
    fields: {
      wallet: { required: true },
    },
  },
  {
    name: 'Neteller',
    localizationShortCode: 'neteller.',
    fields: {
      username: { required: true },
      email: { required: true },
    },
  },
  {
    name: 'Paypal',
    localizationShortCode: 'paypal.',
    fields: {
      username: { required: true },
      email: { required: true },
    },
  },
  {
    name: 'Webmoney',
    localizationShortCode: 'webmoney.',
    fields: {
      username: { required: true },
      wallet: { required: true },
    },
  },
  {
    name: 'Bank transfer',
    localizationShortCode: 'bank_transfer.',
    fields: {
      country_code: {},
      company_name: {},
      company_country: {},
      company_city: {},
      company_address: {},
      company_postal: {},
      bank_name: {},
      bank_country: {},
      bank_address: {},
      bank_city: {},
      iban: {},
      bic: {},
      account_holders_name: {},
      branch_code: {},
      routing_number: {},
    },
  },
  {
    name: 'Visa/Master card',
    localizationShortCode: 'bank_card.',
    fields: {
      username: { required: true },
      card_number: { required: true },
      bank_name: { required: true },
      country: { required: true },
      city: { required: true },
      address: { required: true },
      iban: { required: true },
      bic: { required: true },
      swift: { required: true },
    },
  },
  {
    name: 'Yandex.Money',
    localizationShortCode: 'yandex_money.',
    fields: {
      wallet: { required: true },
    },
  },
  {
    name: 'Qiwi',
    localizationShortCode: 'qiwi.',
    fields: {
      phone_number: { required: true },
    },
  },
  {
    name: 'Capitalist',
    localizationShortCode: 'capitalist.',
    fields: {
      wallet: { required: true },
    },
  },
  {
    name: 'USDT (erc20)',
    localizationShortCode: 'usdt_erc20.',
    fields: {
      wallet: { required: true },
    },
  },
  {
    name: 'USDT (trc20)',
    localizationShortCode: 'usdt_trc20.',
    fields: {
      wallet: { required: true },
    },
  },
  {
    name: 'Skrill',
    localizationShortCode: 'skrill.',
    fields: {
      username: { required: true },
      email: { required: true },
    },
  },
  {
    name: 'Player account',
    localizationShortCode: 'player_account.',
    fields: {
      poker_nickname: { required: true },
    },
  },
  {
    name: 'Bitcoin',
    localizationShortCode: 'bitcoin.',
    fields: {
      wallet: { required: true },
    },
  },
];

export const ADMIN_PAYMENT_SYSTEM_COUNTRIES_URL = 'admin/payment_systems/:id/countries';
export const AFFILIATE_PAYMENT_SYSTEM_COUNTRIES_URL = 'affiliate/payment_systems/countries';
export const AFFILIATE_CASHOUT_PAYMENT_SYSTEM_COUNTRIES_URL = 'affiliate/cashouts/countries';
export const PAYMENT_SYSTEM_COUNTRIES_QUERY_KEY = 'payment_system.countries';

export const ADMIN_PAYMENT_SYSTEM_ALLOWED_URL = 'admin/payment_systems/:id/allowed_payment_systems';
export const AFFILIATE_PAYMENT_SYSTEM_ALLOWED_URL = 'affiliate/payment_systems/allowed_payment_systems';
export const AFFILIATE_CASHOUT_PAYMENT_SYSTEM_ALLOWED_URL = 'affiliate/cashouts/allowed_payment_systems';
export const PAYMENT_SYSTEM_ALLOWED_QUERY_KEY = 'payment_system.allowed';

export const ADMIN_PAYMENT_SYSTEM_WITHDRAWAL_CASHOUT_URL = 'admin/affiliate_cashouts/withdrawals';
export const ADMIN_PAYMENT_SYSTEM_WITHDRAWAL_URL = 'admin/payment_systems/:id/update_payment_system';
export const AFFILIATE_PAYMENT_SYSTEM_WITHDRAWAL_CASHOUT_URL = 'affiliate/cashouts/withdraw';
export const AFFILIATE_PAYMENT_SYSTEM_WITHDRAWAL_URL = 'affiliate/payment_systems/update_payment_system';
export const PAYMENT_SYSTEM_WITHDRAWAL_MUTATION_KEY = 'payment_system.withdrawal';
